<template>
  <main v-if="loaded">
    <div class="header-view">
      <div class="title">{{ $t('comparison.title') }}</div>
      <ul class="time">
        <li>
          <i>{{ $t('comparison.before') }}</i>
          <span>{{first_report_tm}}</span>
        </li>
        <li>
          <i>{{ $t('comparison.after') }}</i>
          <span>{{sec_report_tm}}</span>
        </li>
      </ul>
    </div>

    <!-- 提高项目对比图 -->
    <AlgorithmValueNotice />
    <waterfall-card
        :class="['card-first', { more }]"
        v-if="list.length > 0"
        :title="$t('comparison.improvementProjectChart')"
        :list="list"
        labelKey="item_dict_name"
        :valueKey="valueKey"
        legend
    ></waterfall-card>

    <!-- 有待提高项目比对图 -->
    <waterfall-card
        class="card"
        v-if="more && awaitList.length > 0"
        :title="$t('comparison.awaitImprovementChart')"
        :list="awaitList"
        labelKey="item_dict_name"
        :valueKey="valueKey"
        legend
    ></waterfall-card>

    <waterfall-card
        class="card-last"
        v-if="more && dynamics.length > 0"
        :title="$t('comparison.dynamicComparisonChart')"
        :list="dynamics"
        labelKey="item_dict_name"
        :valueKey="stackValueKey"
        :colorKey="stackColorKey"
        stack="diff"
        tips
        @tip="interpret = true"
    ></waterfall-card>

    <div
        v-if="!more"
        class="more-btn"
    >
      <div class="btn" @click="more = true">{{ $t('actions.viewMore') }}</div>
    </div>

    <!-- 比对数据报告表 -->
    <table-card class="table" :title="$t('comparison.comparisonDataReportTable')" :columns="columns" :list="tableList"></table-card>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" :title="$t('comparison.interpretationTitle')">
      <span v-for="(item, index) in levels" :key="index"><i :style="{background: item.color}"></i>{{item.str}}</span>
    </dialog-view>
  </main>
</template>

<script>
  import WaterfallCard from "@/components/WaterfallCard";
  import {reportCompareInfoH5} from "../net/api";
  import DialogView from "../components/DialogView";
  import TableCard from "../components/TableCard";

  export default {
    name: "Compare",
    components: {TableCard, DialogView, WaterfallCard},

    data() {
      return {
        // 当前数据是否加载完成
        loaded: false,

        packageNo: '',
        checkcode: '',
        rand: '',
        compare_id: '',

        more: false,

        stackColorKey: ['first_color', 'sec_color'],

        // 提高项目对比图
        list: [],
        // 有待提高项目对比图
        awaitList: [],
        // 动态对比图
        dynamics: [],

        // 报告等级列表
        levels: [],
        // 解读说明弹窗
        interpret: false,

        tableList: [],

        // 报告检测时间
        first_report_tm: '',
        sec_report_tm: '',
      }
    },

    computed: {
      // 通用态图列表数据关联项
      valueKey() {
        return {
          first_av: this.$t('comparison.previousDetection'),
          sec_av: this.$t('comparison.laterDetection'),
        };
      },

      stackValueKey() {
        return [{
          first_one: this.$t('comparison.previousInitialValue'),
          first_two: this.$t('comparison.previousFinalValue'),
        }, {
          sec_one: this.$t('comparison.laterInitialValue'),
          sec_two: this.$t('comparison.laterFinalValue'),
        }];
      },

      columns() {
        return {
          item_dict_name: this.$t('comparison.detectionItem'),
          first_av: this.$t('comparison.previousDetection'),
          sec_av: this.$t('comparison.laterDetection'),
          av_difference: {
            name: this.$t('comparison.comparisonResult'),
            value: (row) => {
              let val = row.av_difference;
              return val >= 0 ? this.$t('comparison.improved') : this.$t('comparison.needsImprovement');
            }
          }
        };
      }
    },

    created() {
      const query = this.$router.currentRoute.query;
      this.packageNo = query.packageNo;
      this.checkcode = query.checkcode;
      this.rand = query.rand;
      this.compare_id = query.compare_id;

      this.syncPageData();
    },

    methods: {
      // 同步页面数据
      syncPageData() {
        reportCompareInfoH5({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode,
          compare_id: this.compare_id
        }).then((data) => {
          this.levels = data.colorData || [];
          this.list = data.tableData.upItems;
          this.awaitList = data.tableData.downItems;
          this.dynamics = data.tableData.dongtaiItems;
          this.first_report_tm = data.first_report_tm;
          this.sec_report_tm = data.sec_report_tm;
          this.tableList = data.tableData.xiangxiItems;
          this.loaded = true;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-first {
    padding-bottom: 130px;

    &.more {
      padding-bottom: 20px;
      margin-bottom: 0;
      border-radius: 20px 20px 0 0;
    }
  }
  .card {
    border-radius: 0 0 0 0;
    padding-bottom: 20px;
    margin-bottom: 0;
  }
  .card-last {
    border-radius: 0 0 20px 20px;
  }

  .more-btn {
    position: absolute;
    width: 100%;
    left: 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;

    .btn {
      position: absolute;
      top: -110px;
      width: 160px;
      height: 50px;
      background: #EDF4FF;
      border-radius: 25px;
      font-size: 24px;
      color: #6CA0EC;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .header-view {
    background: #FFFFFF;
    border-radius: 20px;
    margin-bottom: 20px;
    padding: 60px 30px;

    .title {
      display: flex;
      font-size: 50px;
      font-weight: 500;
      color: #333333;
      justify-content: center;
    }

    .time {
      margin-top: 50px;
      display: block;

      li {
        display: flex;
        align-items: center;
        margin-top: 10px;

        &:first-child {
          margin-top: 0;
        }

        i {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: #2F95F6;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-size: 26px;
          font-weight: 600;
          color: #FFFFFF;
          border-radius: 50%;
        }

        span {
          margin-left: 30px;
          font-size: 30px;
          color: #333333;
        }
      }
    }
  }

</style>
